export default __webpack_public_path__ + "static/media/cart.517f1236.svg";